module.exports = __webpack_public_path__ + "img/comment.f5d7121e.png";